"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral([""], [""]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactGridSystem = require("react-grid-system");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledRow = (0, _styledComponents2.default)(_reactGridSystem.Row)(_templateObject);

var Row = function Row(props) {
  return _react2.default.createElement(StyledRow, props);
};

exports.default = Row;